module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image10.0c3bc302.jpg";